var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5H19V18.5H2V1.5ZM11.7149 11.2156C10.979 11.2156 10.3146 11.239 9.65246 11.2022C9.40408 11.1836 9.16869 11.0839 8.98246 10.9185C8.01767 9.99051 7.08414 9.03459 6.13275 8.08983C5.99987 7.95806 5.8547 7.83857 5.67715 7.67887V14.8327H15.3385V5.1707H8.1606C8.36272 5.38511 8.4956 5.53252 8.63407 5.67211C9.55307 6.59341 10.4799 7.5069 11.3866 8.44049C11.5545 8.60406 11.664 8.81831 11.6982 9.05022C11.7373 9.73366 11.7127 10.4227 11.7127 11.2144L11.7149 11.2156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrpIcon);
export default __webpack_public_path__ + "static/media/XRPIcon.c517efec4b253630d6130ba6b085af8e.svg";
export { ForwardRef as ReactComponent };